import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import { logo } from '../assets/images';
import { notificationsIcon, helpIcon } from '../assets/images/icons';
import UserMenu from './UserMenu';

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <img
        className={styles.companyLogoHorizontal2}
        alt="Company Logo"
        src={logo}
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer' }}
      />
      <div className={styles.rightSection}>
        <img className={styles.helpIcon} alt="Help" src={helpIcon} />
        <img className={styles.notificationsIcon} alt="notifications" src={notificationsIcon} title="" />
        <UserMenu />
      </div>
    </div>
  );
};

export default Header;
